import useApiMutation from 'shared/hooks/use-api-mutation';
import useQueryHelpers from 'shared/hooks/use-query-helpers';
import {AdditionalGroupProps} from '../types';
import additionalGroupsKeys from '../util/additional-groups-keys';

const useDisableAdditionalGroupAdditionals = (additionalGroupId: string) => {
  const {setData} = useQueryHelpers();

  const onSuccess = (data: AdditionalGroupProps) => {
    setData(additionalGroupsKeys.additionals(additionalGroupId), data);
  };

  return useApiMutation({
    url: `/additional-groups/${additionalGroupId}/additionals/disable`,
    method: 'PATCH',
    errorTitle: 'Erro ao editar grupo de adicional',
    successTitle: 'Editar grupo de adicional',
    successMessage: 'Grupo de adicional atualizado com sucesso',
    onSuccess,
  });
};

export default useDisableAdditionalGroupAdditionals;
